import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gou",
  "use": "icon-gou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-gou\"><path d=\"M911.652571 201.289143a51.2 51.2 0 0 1 77.824 66.121143l-5.412571 6.29028501-548.937143 549.01028599a51.2 51.2 0 0 1-66.56 4.973714l-6.363428-5.485714L39.497143 490.057143a51.2 51.2 0 0 1 67.145143-76.8l6.290285 5.485714L399.36 713.508571l512.292571-512.219428z\" p-id=\"17601\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol